// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__35OKW","left":"styles_left__uMOqs"};